// @flow
export const filterId: 'customerType' = 'customerType';
